import React, { useContext, useState } from "react";
// import { useDispatch } from "react-redux";
import { Popover, List, Avatar } from "antd/lib";
// Auth Context
import AuthContext from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import FetchImage from "../FetchData/FetchImage";
import { useDispatch, useSelector } from "react-redux";
import {
  onChangeEmployeePosition,
  toggleCollapsedSideNav
} from "../../appRedux/actions";
import IntlMessages from "../../util/IntlMessages";

// interface IUserProfile {
//   direction: string;
//   showUserName: boolean;
// }

const UserInfo = (props: any) => {
  let { navCollapsed } = useSelector(({ sideNav }: any) => sideNav);
  const [showMenu, setShowMenu] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);

  function changeHandler(item: any) {
    // userInfo
    if (authContext.setUserEmployeePosition) {
      // onChangeEmployeePosition
      authContext.setUserEmployeePosition(item);
      dispatch(onChangeEmployeePosition());
      dispatch(toggleCollapsedSideNav(!navCollapsed));
      setShowMenu(false);
      return history.push("/team-work/home");
    }
  }

  let userMenuOptions = (
    <List
      itemLayout="horizontal"
      dataSource={authContext.userRoles}
      renderItem={(item, index) => (
        <List.Item key={index} className="gx-pl-5">
          <List.Item.Meta
            avatar={false}
            title={
              <span
                onClick={() => changeHandler(item)}
                className="gx-fs-sm gx-text-primary gx-pointer"
              >
                {item.fullName}
                {authContext.userEmployeePosition.personCode ===
                  item.personCode && (
                    <img
                      src={require("assets/images/LetterBody/tick.svg")}
                      alt="user-employee-position"
                      style={{ width: "14px" }}
                      className="gx-mx-2 gx-pt-1 gx-pointer gx-position-absolute"
                    />
                  )}
              </span>
            }
            description={
              <div onClick={() => changeHandler(item)} className="gx-pointer">
                <span className="gx-text-orange"> [</span>
                <span className="gx-fs-sm">{item.organizationName}</span>
                <span className="gx-text-orange">] </span>
              </div>
            }
          />
        </List.Item>
      )}
      footer={
        <Link to="/auth/logout">
          <span className="gx-fs-sm">
            <IntlMessages id="topbar.Exit" />
          </span>
        </Link>
      }
    />
  );

  //<FetchImage src={`contactPicture/getContactPicture`} className="gx-size-40" alt="..."  />

  return (
    <Popover
      visible={showMenu}
      onVisibleChange={(val) => setShowMenu(val)}
      title={false}
      overlayClassName="gx-popover-horizantal"
      placement="bottomRight"
      content={userMenuOptions}
      trigger="click"
    >
      <FetchImage
        src={`contactPicture/getContactPicture`}
        className="gx-size-40"
        alt="..."
      />
    </Popover>
  );
};

export default UserInfo;
